import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-download-app-ios",
  templateUrl: "./download-app-ios.component.html",
  styleUrls: ["./download-app-ios.component.scss"],
})
export class DownloadAppIosComponent implements OnInit {
  constructor() {}
  ngOnInit() {}
}
